export default "__VITE_ASSET__CbDSHuy5__"